import type { ApiQuote } from '../../types/api';
import { apiUrl } from '../../config/runtime';
import { cachedRequest } from './cache';
import { apiFetch } from './client';

export const quoteBatchSize = 10;
export const quoteEventsMaxSymbols = 20;

export function fetchQuotes(symbols: string[]): Promise<ApiQuote[]> {
  const uniqueSymbols = [...new Set(symbols.map((symbol) => symbol.trim().toUpperCase()).filter(Boolean))];
  if (uniqueSymbols.length === 0) return Promise.resolve([]);

  return cachedRequest(`quotes:${uniqueSymbols.join(',')}`, 5_000, () => apiFetch<ApiQuote[]>('/api/quotes', {
    method: 'POST',
    body: JSON.stringify({ symbols: uniqueSymbols }),
  }));
}

export function createQuotesEventSource(symbols: string[]): EventSource {
  const uniqueSymbols = [...new Set(symbols.map((symbol) => symbol.trim().toUpperCase()).filter(Boolean))];
  const params = new URLSearchParams({ symbols: uniqueSymbols.join(',') });
  return new EventSource(apiUrl(`/api/quotes/events?${params.toString()}` as `/api/${string}`), { withCredentials: true });
}

export function chunkQuoteSymbols(symbols: string[], batchSize = quoteBatchSize): string[][] {
	const uniqueSymbols = [...new Set(symbols.map((symbol) => symbol.trim().toUpperCase()).filter(Boolean))];
	const groups: string[][] = [];
	for (let index = 0; index < uniqueSymbols.length; index += batchSize) {
		groups.push(uniqueSymbols.slice(index, index + batchSize));
	}
	return groups;
}
